import { Component, Inject, Optional } from '@angular/core';

// RadioBaseDirective needs to be imported before RadioBadgeGroupComponent to avoid circular dependency issues
// prettier-ignore
import { RadioBaseDirective } from './radio-base.directive';

import { RadioBadgeGroupComponent, SB_RADIO_BADGE_GROUP } from '../radio-badge-group/radio-badge-group.component';

@Component({
  selector: 'sb-radio-badge',
  standalone: true,
  exportAs: 'sbRadioBadge',
  templateUrl: './radio-badge.component.html',
})
export class RadioBadgeComponent extends RadioBaseDirective {
  constructor(@Optional() @Inject(SB_RADIO_BADGE_GROUP) override radioGroup: RadioBadgeGroupComponent) {
    super(radioGroup);
  }
}
